import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-racs-metadata',
  templateUrl: './racs-metadata.component.html',
  styleUrls: []
})
export class RacsMetadataComponent {
  @Input() chatdata: any;
  @Input() configdata: any; // Added line to accept configdata as input
  metadata: any;
  error: boolean = false;
  errorMessage: string = '';
  constructor() { }
}
